import React from "react";

import styles from "./help-popover-button-link.module.scss";

interface HelpPopoverButtonPropTypes {
  icon: string;
  link: string;
  text: string;
  altText: string;
  targetBlank?: boolean;
}

const cssClassName = "help-popover-button-link";

export const HelpPopoverButtonLink = ({
  icon,
  link,
  text,
  altText,
  targetBlank = true,
}: HelpPopoverButtonPropTypes) => {
  return (
    <a
      className={styles[`${cssClassName}`]}
      href={link}
      rel="noreferrer"
      target={targetBlank ? "_blank" : undefined}
    >
      <img src={icon} alt={altText} />
      {text}
    </a>
  );
};
